module.exports = __webpack_public_path__ + "static/28-billie-8a1f768e4865d2dcc1ecb7f2b4324f8c.jpg";